import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import { Button } from '@wds/button';
import { Modal } from '@wds/modal';

import uninstallAppMutation from '../../../components/RemoveApp/remove-app.graphql';

const UninstallButton = ({ appId, onSuccess, onClose, color, stretched }) => {
  const [confirmDialogVisible, setConfirmDialogVisible] = useState(false);
  return (
    <>
      <Button
        onClick={() => setConfirmDialogVisible(true)}
        data-testid="UninstallButton"
        color={color}
        stretched={stretched}
      >
        Uninstall
      </Button>
      <Mutation
        mutation={uninstallAppMutation}
        variables={{ input: { appId } }}
        onCompleted={() => {
          setConfirmDialogVisible(false);
          onSuccess();
        }}
      >
        {(uninstallApp, { loading }) => {
          return (
            <Modal
              data-testid="UninstallButton__Dialog"
              show={confirmDialogVisible}
              size="md"
              onClose={() => {
                setConfirmDialogVisible(false);
                onClose();
              }}
            >
              <Modal.Header>Remove App</Modal.Header>
              <Modal.Body>Would you like to uninstall this app?</Modal.Body>
              <Modal.Footer align="right">
                <Button color="warning" onClick={uninstallApp} disabled={loading || !appId}>
                  Uninstall
                </Button>
                <Button
                  onClick={() => {
                    setConfirmDialogVisible(false);
                    onClose();
                  }}
                  color="alt"
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          );
        }}
      </Mutation>
    </>
  );
};

UninstallButton.propTypes = {
  appId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  color: PropTypes.string,
  stretched: PropTypes.bool,
};

UninstallButton.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
  color: 'alt',
  stretched: false,
};

export default UninstallButton;
